import Vue from 'vue';
import Router from 'vue-router';
import NProgress from 'nprogress'; // progress bar
import 'nprogress/nprogress.css'; // progress bar style
// import Dashboard from '@/components/Dashboard';
// import Login from '@/components/Login';
// import Signup from '@/components/Signup';
// import Profile from '@/components/Profile';
// import Verify from '@/components/Verify';
// import Home from '@/components/Home';
// import EventBus from '../Buss/EventBus';
// import luxtagApi from '../API/index';
// code splitting in action for routs
// this will layzily load the rout by issuing a promise to webpack
const Home = () => import('@/components/Home');
const Dashboard = () => import('@/components/Dashboard');
const Login = () => import('@/components/Login');
const Signup = () => import('@/components/Signup');
const Profile = () => import('@/components/Profile');
const Verify = () => import('@/components/Verify');
const Product = () => import('@/components/product');
const Reset = () => import('@/components/Reset');
const Forgot = () => import('@/components/Forgot');
const Faq = () => import('@/components/Faq');

Vue.use(Router);

// NProgress.start();

function requireAuth(to, from, next) {
  if (localStorage.LuxTag) {
    if (JSON.parse(localStorage.LuxTag).auth.login) {
      next();
    } else {
      next('/');
    }
  } else {
    next('/');
  }
}

function notRequireAuth(to, from, next) {
  if (localStorage.LuxTag) {
    if (JSON.parse(localStorage.LuxTag).auth.login) {
      next('/dashboard');
    } else {
      next();
    }
  } else {
    next();
  }
}

const router = new Router({
  // mode: 'history', we will use this option to remove # from url
  // but we need to convigure the server first
  // https://router.vuejs.org/en/essentials/history-mode.html
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home,
      beforeEnter: notRequireAuth,
    },
    {
      path: '/verify',
      name: 'Verify',
      component: Verify,
    },
    {
      // Sign UP will be rendered inside User's <router-view>
      path: '/sign-up',
      name: 'Sign-up',
      component: Signup,
      beforeEnter: notRequireAuth,
    },
    {
      // Login will be rendered inside User's <router-view>
      path: '/login',
      name: 'Login',
      component: Login,
      beforeEnter: notRequireAuth,
    },
    {
      path: '/forgot',
      name: 'Forgot',
      component: Forgot,
      beforeEnter: notRequireAuth,
    },
    {
      path: '/reset/:token',
      name: 'Reset',
      component: Reset,
    },
    {
      path: '/dashboard',
      name: 'Dashboard',
      component: Dashboard,
      beforeEnter: requireAuth,
    },
    {
      path: '/profile',
      name: 'Profile',
      component: Profile,
      beforeEnter: requireAuth,
    },
    {
      // Products will be rendered inside User's <router-view>
      path: '/product/:address',
      name: 'Product',
      component: Product,
    },
    {
      path: '/faq',
      name: 'FAQ',
      component: Faq,
      beforeEnter: requireAuth,
    },
  ],
});

router.beforeEach((to, from, next) => {
  /* luxtagApi.user.isActive().then((response) => {
    // console.log(response);
    if (typeof (response) === 'boolean') {
      EventBus.$emit('got-account-status', response);
    } else {
      throw new Error(response);
    }
  }); */
  NProgress.start();
  next();
});

router.afterEach(() => {
  NProgress.done(); // finish progress bar
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js